module.exports = __webpack_public_path__ + "static/img/12.610e0be.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/12.png
// module id = +X1j
// module chunks = 6